import { render, staticRenderFns } from "./ConceptOverview.vue?vue&type=template&id=54730c8a&scoped=true&"
import script from "./ConceptOverview.vue?vue&type=script&lang=ts&"
export * from "./ConceptOverview.vue?vue&type=script&lang=ts&"
import style0 from "./ConceptOverview.vue?vue&type=style&index=0&id=54730c8a&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54730c8a",
  null
  
)

export default component.exports